<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import SupportHead from './_SupportHead.vue'
import SupportMethods from './_SupportMethods.vue'
import SupportFooter from './_SupportFooter.vue'

import locator from '@/service-locator'
import { maskPhoneNumber } from '@/utils/logger'

export default {
  name: 'SidebarSupportWidget',
  components: {
    SupportHead,
    SupportMethods,
    SupportFooter,
  },
  data() {
    return {
      status: '',
      errorMessage: '',
    }
  },
  computed: {
    ...mapState('merchantSupport', ['submitting']),
    ...mapGetters('userProfile', ['selectedMerchant']),
    ...mapGetters('profile', {
      merchantProfile: 'profile',
      shouldAllowRequestCallback: 'shouldAllowRequestCallback',
    }),
  },
  methods: {
    ...mapActions('merchantSupport', ['submitCallbackRequest']),
    async handleChatWithUs() {
      await locator.sfChatbot.openChatbot()
    },
    async handleSubmitCallback(data) {
      this.status = 'submitting'
      this.errorMessage = ''

      try {
        await this.submitCallbackRequest({
          merchantId: this.selectedMerchant,
          ...data,
        })

        this.status = 'success'
      } catch (error) {
        this.$logger.noticeError(error, {
          merchantId: this.selectedMerchant,
          phoneNumber: maskPhoneNumber(data.phoneNumber),
        })

        this.status = 'failed'
        this.errorMessage = error?.response?.data?.message
      }
    },
  },
}
</script>

<template>
  <div class="sidebar-support-widget is-lavender-design">
    <SupportHead />
    <SupportMethods
      class="mt-6"
      :submitting="submitting"
      :status="status"
      :merchant-profile="merchantProfile"
      :support-callback-visible="shouldAllowRequestCallback"
      :error-message="errorMessage"
      @click:chat-with-us="handleChatWithUs"
      @click:submit-callback="handleSubmitCallback"
    />
    <SupportFooter class="mt-4" />
  </div>
</template>

<style lang="scss" scoped>
.sidebar-support-widget {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 240px;
  padding: 16px;
  background-color: var(--tamara-color-background-neutral-mid);
  border-radius: 8px;
}
</style>
